import { createFileRoute } from "@tanstack/react-router";
import { TermsContent } from "@/components/legal/terms";
import { Language } from "@linqx/i18n";
import { seo } from "@/lib/seo";

export const Route = createFileRoute("/terms")({
  head: () => ({
    meta: seo({
      title: Language.getKey("landing_meta_terms_title"),
      description: Language.getKey("landing_meta_terms_description"),
      url: "https://getlinqx.com/terms",
    }),
  }),
  component: TermsContent,
});
